import React from 'react';
import RefundRequestsPage from '../components/RefundRequestsPage';

const RefundRequestsApp = (props) => (
  <RefundRequestsPage {...props} />
);

export default RefundRequestsApp;
